export default __webpack_public_path__ + "static/media/xianshi_s.76189a87.png";